const defaultTheme = require('tailwindcss/defaultTheme');

module.exports = {
    mode: 'jit',
    content: ['./src/**/*.{js,jsx,ts,tsx,vue}', './static/*.ejs'],
    theme: {
        screens: {
            xxs: '200px',
            xs: '475px',
            '1.5xl': '1440px',
            ...defaultTheme.screens,
        },
        extend: {
            fontFamily: {
                sans: ['Urbanist', 'Gotham', 'sans-serif'],
                'icon-font': ['icon-font', 'sans-serif'],
                'urbanist': ['Urbanist', 'Gotham', 'sans-serif'],
            },
            spacing: {
                '4.5': '18px',
                '5.5': '22px',
                '6.5': '26px',
            },
            borderRadius: {
                '2.5': '10px',
                '3.5': '14px',
                '5': '20px',
                '10': '40px',
            },
            height: {
                screen: '100dvh',
            },
            minHeight: {
                screen: '100dvh',
            },
            colors: {
                transparent: 'transparent',
                current: 'currentColor',
                white: '#ffffff',
                'border-field' : '#1D2B4214',
                'brand-pink': '#FF128B',
                'brand-orange': '#F1770D',
                navy: {
                    DEFAULT: '#020E54',
                    5: '#000f510D',
                    60: '#000f5199',
                },
                brandNavy : {
                    DEFAULT: "#1D2B42",
                    muted: "#1D2B4266",   
                },
                brandMint : {
                    DEFAULT: '#61A183',
                    calm: '#83C0A3',
                    muted : '#83C0A33D'
                },
                brandGrey : {
                    secondary : '#8A8A8A'
                },
                'brand-divider': '#9F9F9F3D',
                space: {
                    'navy-deeper': '#000B3E',
                    'navy-ink': '#000F51',
                    'surface-soft': '#F8F8F8',
                    'surface-hover': '#F9FAFB',
                    'surface-selected': '#E8F6F0',
                    'step-inactive': '#E2E6EF',
                    'text-slate': '#8E95A1',
                    'text-slate-strong': '#7A8093',
                    'text-muted': '#949494',
                    'text-muted-deep': '#818181',
                    'shadow-soft': '#6C7B943D',
                    'shadow-soft-strong': '#73869A29',
                    'scroll-thumb': '#A8A8A8',
                    'scroll-track-shadow': '#53535312',
                    'overlay-backdrop': '#F0F1F366',
                    'page-bg': '#F8F9FA',
                    'icon-muted': '#9CA3AF',
                    'accent-magenta': '#E6007E',
                    destructive: '#E11D48',
                    'destructive-hover': '#BE123C',
                    'navy-strong': '#000033',
                    'navy-stronger': '#000044',
                    'pink-alt': '#FF1493',
                    'white-0': '#FFFFFF00',
                    'white-40': '#FFFFFF66',
                    'white-80': '#FFFFFFCC',
                    'black-0': '#00000000',
                    'black-16': '#00000029',
                },
                indigo: '#070d25',
                'wannabe-dutty': '#0000000D',
                'dusk-stalk': '#000f5180',
                'dawn-stalk': '#000f5133',
                'bruised-ego': '#7f85ad',
                'dutty-grey': '#c1c1c1',
                'lighter-grey': '#d8d8d8',
                'light-bite': '#b2b7ca',
                'unknown-grey': {
                    DEFAULT: '#bfc3d3',
                    200: '#e2e2e2',
                    300: '#f1f1f1',
                    400: '#7f87a8',
                    500: '#e1e2ea',
                    600: '#7880a3',
                },
                'strangle-hold-blue': '#4743f7',
                'blue-in-the-face': '#5dafe7',
                'mountain-meadow': '#16D496',
                'carnation-pink': '#fe95cb',
                mustard: '#fedb59',
                terracotta: '#e7675e',
                'surface-base': '#F3F3F3',
                'turquoise-primary': '#76A5AF',
                'turquoise-secondary': '#367987',
                'turquoise-24':'#69B6C63D',

                'disable-color' : '#1D2B4229',
                'disable-bg' : '#020E540A'

            },
            backgroundImage: {
                'space-box': "url('/static/assets/images/misc/spacebox.png')",
                'serendipity-labs':
                    "url('/static/assets/images/misc/serendipity-labs.png')",
                'grey-star': "url('/static/assets/images/misc/greystar.png')",

                'blue-noise':
                    "linear-gradient(to bottom, theme('colors.navy.DEFAULT') 30%, transparent 120%), url('/static/assets/images/misc/noise-blue.png')",
                'blue-noise-1':
                    "linear-gradient(to bottom, theme('colors.navy.DEFAULT') 0%, theme('colors.navy.60') 30%), url('/static/assets/images/misc/noise-blue.png')",
                'blue-noise-2':
                    "linear-gradient(to bottom, theme('colors.navy.DEFAULT') 0%, theme('colors.navy.60') 60%), url('/static/assets/images/misc/noise-blue.png')",
                'white-noise':
                    "url('/static/assets/images/misc/noise-white.png')",

                'flushy-pink-gradient':
                    "linear-gradient(130deg, theme('colors.turquoise-primary') 38%, theme('colors.navy.DEFAULT') 238%)",
                'bloody-nose-gradient':
                    "linear-gradient(130deg, theme('colors.turquoise-primary') 0%, theme('colors.turquoise-primary') 100%)",
            },
            boxShadow: {
                thin: "0 1px 0 0 theme('colors.lighter-grey')",
                ambient: '0 13px 13px 0 rgba(0, 0, 0, 0.1)',
                input: '0 7px 7px 0 rgba(0, 0, 0, 0.05)',
                price: '0 2px 13px 0 rgba(0, 0, 0, 0.32)',
                view: '-13px 0 13px 0 rgba(0, 0, 0, 0.5)',
            },
            fontSize: {
                h3: "clamp(20px,2.7svw,40px)", 
                p : "clamp(16px,1.3svw,20px)"
      },
            
        },
    },
    variants: {
        extend: {
            visibility: ['group-hover'],
            display: ['group-hover'],
            colors: ['disabled'],
        },
    },
};
